module.exports = __webpack_public_path__ + "img/elemento-grafico.ed7b6431.svg";